import React, { useState, useRef } from "react";

const Unauthorized = (props) => {

  return (
    <div id="app">
   <div>403</div>
   <div class="txt">
      Forbidden<span class="blink">_</span>
   </div>
</div>
  );
};

export default Unauthorized;
